import React from 'react';

import { DecisionMakingAuthorization } from '@ndvr/auth-api';

import { titleCase } from 'utils';
import { FormRadioButtons, getFieldName, VerticalLayout } from 'widgets';

export const AuthorizationFields = ({ label, prefix }: { label: string; prefix?: string }) => (
    <VerticalLayout $gap={16}>
        <FormRadioButtons
            required
            name={getFieldName('portfolioManagementAuthorization', prefix)}
            title={`${label} authorization for portfolio management`}
            values={[
                {
                    label: titleCase(DecisionMakingAuthorization.ON_BEHALF_OF_ALL),
                    value: DecisionMakingAuthorization.ON_BEHALF_OF_ALL,
                },
                {
                    label: titleCase(DecisionMakingAuthorization.BY_MAJORITY),
                    value: DecisionMakingAuthorization.BY_MAJORITY,
                },
                {
                    label: titleCase(DecisionMakingAuthorization.ALL_REQUIRED),
                    value: DecisionMakingAuthorization.ALL_REQUIRED,
                },
            ]}
        />
        <FormRadioButtons
            required
            name={getFieldName('withdrawalsAuthorization', prefix)}
            title={`${label} authorization for withdrawals`}
            values={[
                {
                    label: titleCase(DecisionMakingAuthorization.ON_BEHALF_OF_ALL),
                    value: DecisionMakingAuthorization.ON_BEHALF_OF_ALL,
                },
                {
                    label: titleCase(DecisionMakingAuthorization.BY_MAJORITY),
                    value: DecisionMakingAuthorization.BY_MAJORITY,
                },
                {
                    label: titleCase(DecisionMakingAuthorization.ALL_REQUIRED),
                    value: DecisionMakingAuthorization.ALL_REQUIRED,
                },
            ]}
        />
    </VerticalLayout>
);
